import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useOasaraAuth } from '../../hooks/useEcosystemAuthInit';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

// Reads from the ecosystem auth client (FreedomForge) where sign-in actually
// happens. Previously read the per-site supabase client which has no session,
// so signed-in users bounced to /auth then home. Unified Auth Board 2026-05-11.
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, session, loading, initialized } = useOasaraAuth();
  const location = useLocation();

  // Still initializing - show loading
  if (!initialized || loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-sage-50 via-sage-100/30 to-sage-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-br from-gold-400 to-gold-600 flex items-center justify-center shadow-lg animate-pulse">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z" />
            </svg>
          </div>
          <p className="text-ocean-600/70">Loading...</p>
        </div>
      </div>
    );
  }

  // Not authenticated - redirect to auth
  if (!user && !session) {
    // Save the intended destination
    localStorage.setItem('oasara-auth-redirect', location.pathname);
    return <Navigate to="/auth" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
